import script from "./WelcomeWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeWidget.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeWidget.vue?vue&type=style&index=0&id=eb97b200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb97b200"]])

export default __exports__